import {
  Autocomplete,
  TextField,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { SingleAutocompleteProps } from "@/app/interfaces/props/SingleAutocompleteProps";

const SingleAutocomplete = ({
  label,
  value,
  options,
  onChange,
  name,
  error = false,
  helperText,
  required = false,
  size = "small",
  disabled = false,
  placeholder,
}: SingleAutocompleteProps) => {
  return (
    <FormControl
      fullWidth
      error={error}
      required={required}
      size={size}
      disabled={disabled}
    >
      <Autocomplete
        value={value}
        onChange={onChange}
        options={options}
        getOptionLabel={(option) => option.text}
        isOptionEqualToValue={(option, val) => option.value === val.value}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            name={name}
            error={error}
            required={required}
            size={size}
            disabled={disabled}
            sx={{
              borderRadius: "4px",
              padding: "0px !important",
              width: "100%",
              color: "#000",
              alignItems: "baseline",
              "& .MuiOutlinedInput-root": {
                padding: "3px !important",
                "& fieldset": {
                  borderColor: "#d9d9d9",
                  borderRadius: "4px",
                },
              },
            }}
          />
        )}
        disablePortal
        disabled={disabled}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SingleAutocomplete;
